<template>
  <install-page from-express></install-page>
</template>
<script>
import InstallPage from "@/view/pages/static/install-old.vue";
export default {
  components: { InstallPage },
};
</script>
